// =====================================================
// SCHEMA: TASK
// Description: Schéma Zod pour validation création tâche
// =====================================================

import { z } from 'zod';

export const createTaskSchema = z.object({
  title: z.string().min(1, 'Titre requis'),
  type: z.enum(['call', 'email', 'meeting', 'other']),
  date: z.string().min(1, 'Date requise'),
  time: z.string().optional(),
  assigned_to: z.string().nullable().optional(),
  notes: z.string().optional(),
});

export type CreateTaskInput = z.infer<typeof createTaskSchema>;
